// Site-wide data for Modern Arch (Modern Group Nagpur)

export const companyInfo = {
  name: "Modern Arch",
  tagline: "Building Dreams, Creating Landmarks",
  fullName: "Modern Group Nagpur",
  phone: "+91 8766 551 928  / 0712-4102028",
  primaryPhone: "+918766551928",
  secondaryPhone: "07124102028",
  email: "modern.office.nagpur@gmail.com",
  address: "Flot 102, Shri Mangalam Lotus Apartment, behind Bakade Celebration, Manewada Square, Nagpur -440024",
  workingHours: "Mon - Sat: 10:00 AM - 7:00 PM",
  founded: "1998",
  projectsCompleted: "10+",
  happyFamilies: "250+",
  sqftDelivered: "1 Million",
  socialLinks: {
    facebook: "https://facebook.com/modernarch",
    instagram: "https://instagram.com/modernarch",
    linkedin: "https://linkedin.com/company/modernarch",
    twitter: "https://twitter.com/modernarch",
    youtube: "https://youtube.com/modernarch"
  }
};

export const heroSlides = [
  {
    id: 1,
    title: "Modern Height",
    subtitle: "Premium Residential & Commercial Projects in Nagpur",
    image: "https://images.unsplash.com/photo-1549665600-42c9e852661e?w=1920&q=80",
    cta: "Explore Projects",
    link: "/projects"
  },
  {
    id: 2,
    title: "Modern Villa Enclave",
    subtitle: "Exclusive 4 & 5 BHK Luxury Villas - Pre-Launch Offers Available",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80",
    cta: "Learn More",
    link: "/projects/modern-villa-enclave"
  },
  {
    id: 3,
    title: "Modern Arch Heights",
    subtitle: "Premium 2, 3 & 4 BHK Apartments in Dharampeth",
    image: "https://images.unsplash.com/photo-1617788587804-10346bac2ac3?w=1920&q=80",
    cta: "View Details",
    link: "/projects/modern-arch-heights"
  }
];

export const usps = [
  {
    icon: "Shield",
    title: "Trusted Legacy",
    description: "25+ years of excellence in real estate development"
  },
  {
    icon: "Award",
    title: "Quality Assurance",
    description: "Premium materials and finest craftsmanship"
  },
  {
    icon: "Clock",
    title: "On-Time Delivery",
    description: "100% track record of timely project completion"
  },
  {
    icon: "Leaf",
    title: "Sustainable Design",
    description: "Eco-friendly construction practices"
  },
  {
    icon: "Compass",
    title: "Vastu Compliance",
    description: "Vastu compliant designs for peace and prosperity"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    designation: "Business Owner",
    project: "Modern Skyline Residency",
    content: "Buying a home at Modern Skyline was the best decision. The quality of construction and attention to detail exceeded our expectations. Highly recommend Modern Arch!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Priya Deshmukh",
    designation: "IT Professional",
    project: "Modern Embassy Towers",
    content: "Our office at Modern Embassy Towers has been instrumental in our company's growth. World-class facilities and excellent location. Modern Group delivers what they promise.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Dr. Anil Patil",
    designation: "Medical Professional",
    project: "Modern Arch Heights",
    content: "The transparency throughout the buying process was commendable. From booking to possession, everything was smooth. Modern Arch truly cares about their customers.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  }
];

export const services = [
  {
    id: "construction",
    title: "Construction Services",
    icon: "Building2",
    shortDesc: "End-to-end construction solutions with premium quality materials and expert craftsmanship.",
    fullDesc: "Our construction services encompass every aspect of building development, from foundation to finishing. We use only the highest quality materials and employ skilled craftsmen to ensure structural integrity and aesthetic excellence.",
    features: [
      "Residential Building Construction",
      "Commercial Complex Development",
      "Industrial Facility Construction",
      "Renovation & Remodeling",
      "Project Management"
    ]
  },
  {
    id: "development",
    title: "Development Services",
    icon: "Landmark",
    shortDesc: "Comprehensive real estate development from land acquisition to project completion.",
    fullDesc: "We handle the complete development lifecycle including land identification, feasibility studies, design planning, regulatory approvals, and project execution to deliver turnkey real estate solutions.",
    features: [
      "Land Acquisition & Due Diligence",
      "Feasibility Analysis",
      "Architectural Planning",
      "Regulatory Approvals",
      "Infrastructure Development"
    ]
  },
  {
    id: "consulting",
    title: "Consulting Services",
    icon: "Users",
    shortDesc: "Expert guidance for real estate investments and development strategies.",
    fullDesc: "Leverage our 25+ years of industry experience for strategic advice on real estate investments, market analysis, and development consulting to maximize your returns.",
    features: [
      "Investment Advisory",
      "Market Research & Analysis",
      "Property Valuation",
      "Legal & Regulatory Guidance",
      "Portfolio Management"
    ]
  }
];

export const processSteps = [
  { step: 1, title: "Consultation", desc: "Understanding your requirements and vision" },
  { step: 2, title: "Planning", desc: "Detailed architectural and structural planning" },
  { step: 3, title: "Approval", desc: "Securing all necessary regulatory approvals" },
  { step: 4, title: "Construction", desc: "Quality construction with regular updates" },
  { step: 5, title: "Handover", desc: "Timely delivery with complete documentation" }
];

export const teamMembers = [
  {
    name: "Mr. Milind Gore",
    position: "Founder & Chairman",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop",
    bio: "With 30+ years of experience as a PWD Nagpur Government Contractor, he ensures strong construction quality, durability, and structural safety across all projects."
  },
  {
    name: "Mr. Krishan Kumar Sarda",
    position: "Managing Director",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    bio: "A respected businessman and the force behind Raghav Trade Link, bringing deep expertise in construction materials and cement quality standards."
  },
  {
    name: "Mr. Narayan Sarda",
    position: "Executive Director",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop",
    bio: "An RCOEM engineer and Vastu expert focused on smart building planning and 100% Vastu-compliant apartment designs."
  },
  {
    name: "Mr. Anirudhha Gore",
    position: "Executive Director",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop",
    bio: "A Civil Engineer from Walchand College with an MBA from IIM Indore, leading strategic growth with a balance of technical and modern management expertise."
  }
];

export const achievements = [
  { year: "1998", title: "Company Founded", desc: "Modern Group established in Nagpur" },
  { year: "2005", title: "First Major Project", desc: "Completed Modern Plaza with 100 units" },
  { year: "2012", title: "Commercial Expansion", desc: "Entered commercial real estate sector" },
  { year: "2018", title: "20 Years Milestone", desc: "Celebrated 20 years with 30+ completed projects" },
  { year: "2023", title: "Green Building Certification", desc: "First IGBC certified project in the region" }
];

export const faqs = [
  {
    question: "What types of properties does Modern Arch offer?",
    answer: "Modern Arch offers a diverse portfolio including luxury apartments, premium villas, commercial office spaces, and retail complexes across prime locations in Nagpur."
  },
  {
    question: "Are your projects RERA registered?",
    answer: "Yes, all our projects are registered with Maharashtra RERA. We maintain complete transparency and compliance with all regulatory requirements."
  },
  {
    question: "What payment options are available?",
    answer: "We offer flexible payment plans including construction-linked plans, down payment schemes, and tie-ups with major banks for home loans at competitive rates."
  },
  {
    question: "Do you provide customization options?",
    answer: "Yes, for our villa projects and select premium apartments, we offer customization options for interiors, fixtures, and finishes based on your preferences."
  },
  {
    question: "What is the typical construction quality standard?",
    answer: "We use only premium quality materials - ACC/Ultratech cement, Tata/SAIL steel, branded electrical fittings, and high-quality vitrified tiles. All constructions are earthquake resistant."
  },
  {
    question: "How can I schedule a site visit?",
    answer: "You can schedule a site visit by calling us at +91 8766551928, filling out the contact form on our website, or visiting our corporate office during working hours."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Things to Consider Before Buying Your First Home",
    excerpt: "Making your first home purchase? Here are the essential factors every first-time buyer should consider.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
    date: "January 15, 2026",
    category: "Buying Guide"
  },
  {
    id: 2,
    title: "The Rise of Smart Homes in Modern Real Estate",
    excerpt: "How technology is transforming residential spaces and what it means for homeowners.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
    date: "January 10, 2026",
    category: "Trends"
  },
  {
    id: 3,
    title: "Nagpur's Real Estate Market: 2026 Outlook",
    excerpt: "An analysis of Nagpur's property market trends and investment opportunities for the year ahead.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80",
    date: "January 5, 2026",
    category: "Market Insights"
  }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Projects", path: "/projects" },
  { name: "Services", path: "/services" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" }
];
